import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { push } from 'connected-react-router';

import {TreeViewNode} from 'interfaces/models';
import {AppThunk} from 'app/store';
import {startLoading, endLoading} from 'app/apiSlice';
import {getFilterId, getFilterTree} from 'api';
import * as appRoutes from 'app/appRoutes';
import errorHandler from '../shared/errorHandler';

interface SelectFilterState {
    filterTree: TreeViewNode[],
    filterId: string | null,
    filterNeedsReview: boolean,
    selectedTreeItems: string[],
    expandedTreeItems: string[]
}

const initialState: SelectFilterState = {
    filterTree: [],
    filterId: null,
    filterNeedsReview: true,
    selectedTreeItems: [],
    expandedTreeItems: []
};

const selectFilterSlice = createSlice({
    name: 'selectFilter',
    initialState,
    reducers: {
        setFilterTree: (state, action: PayloadAction<TreeViewNode[]>) => {
            state.filterTree = action.payload;
        },
        setFilterId: (state, action: PayloadAction<string>) => {
            state.filterId = action.payload;
        },
        treeSelect: (state, action: PayloadAction<string[]>) => {
            state.selectedTreeItems = action.payload;
        },
        treeExpand: (state, action: PayloadAction<string[]>) => {
            state.expandedTreeItems = action.payload;
        },
        setFilterNeedsReview: (state, action: PayloadAction<boolean>) => {
            state.filterNeedsReview = action.payload;
        }
    }
});

export const {treeSelect, treeExpand, setFilterNeedsReview} = selectFilterSlice.actions;
export default selectFilterSlice.reducer;

export const fetchFilterTree = (reload: boolean): AppThunk<void> => async (dispatch, getState) => {
    const token = getState().oidc.user?.access_token;
    if (!token) return;
    dispatch(startLoading('fetchFilterTree'));
    try {
        const response = await getFilterTree(token, reload);
        dispatch(selectFilterSlice.actions.setFilterTree(response.data));
    } catch (err) {
        errorHandler('fetchFilterTree error', err);
    }
    dispatch(endLoading('fetchFilterTree'));
};

export const fetchFilterId = (): AppThunk<void> => async (dispatch, getState) => {
    const token = getState().oidc.user?.access_token;
    if (!token) return;
    dispatch(startLoading('fetchFilterId'));
    try {
        const selectedTreeItems = getState().selectFilter.selectedTreeItems;
        const response = await getFilterId(token, selectedTreeItems);
        dispatch(selectFilterSlice.actions.setFilterId(response.data.filterId));
    } catch (err) {
        errorHandler('fetchFilterId error', err);
    }
    dispatch(endLoading('fetchFilterId'));
}

export const redirectToImages = (): AppThunk<void> => async (dispatch, getState) => {
    const state = getState();
    const {filterId, filterNeedsReview} = state.selectFilter;
    if (!filterId) return;
    
    const reviewedAfter = filterNeedsReview ? new Date().getTime() : 0;
    const route = appRoutes.imagesRoute(filterId, reviewedAfter, 0);
    dispatch(push(route));
};